import React, { Component } from "react";
import "./FastQuizDifficultyPage.scss";
import OptionsMenuPageHeader from "../../OptionsMenuPageHeader";
import { connect } from "react-redux";
import $ from "jquery";
import LoaderComponent from "../../LoaderComponent";

//=============================================================================
// Class FastQuizDifficultyPage
//=============================================================================
class FastQuizDifficultyPage extends Component {
  constructor() {
    super();
    this.state = {
      isLoading: true,
      difficultyLevelOptions: [],
      maxQuestions: [
        [
          {
            id: 1,
            title: "5",
            value: "5",
          },
          {
            id: 2,
            title: "10",
            value: "10",
          },
        ],
        [
          {
            id: 3,
            title: "25",
            value: "25",
          },
          {
            id: 4,
            title: "All",
            value: "0",
          },
        ],
      ],
      selectedDifficultyLevel: "E",
      selectedMaxQuestions: "10",
      setFixedBtn: false,
    };
  }

  //---------------------------------------------------------------------------
  componentDidMount() {
    const { cookies, questionSetDetails } = this.props;
    const existingCookie = cookies.get("app_settings");

    if (existingCookie) {
      if (existingCookie.quiz_settings.diff)
        this.setState({
          selectedDifficultyLevel: existingCookie.quiz_settings.diff,
        });
      if (existingCookie.quiz_settings.questions)
        this.setState({
          selectedMaxQuestions: existingCookie.quiz_settings.questions,
        });
    }
    let difficultyLevelOptions = [
      [
        {
          id: 1,
          title: "Easy",
          sub_title: questionSetDetails.QuestionCountEasy + " Questions",
          value: "E",
        },
        {
          id: 2,
          title: "Medium",
          sub_title: questionSetDetails.QuestionCountMed + " Questions",
          value: "M",
        },
      ],
      [
        {
          id: 3,
          title: "Hard",
          sub_title: questionSetDetails.QuestionCountHard + " Questions",
          value: "H",
        },
        {
          id: 4,
          title: "All",
          sub_title: questionSetDetails.QuestionCountAll + " Questions",
          value: "A",
        },
      ],
    ];
    this.setState(
      {
        isLoading: false,
        difficultyLevelOptions,
      },
      () => {
        this.resetActionButtonPosition();
        this.interval = setInterval(() => {
          this.resetActionButtonPosition();
        }, 10);
        setTimeout(() => {
          clearInterval(this.interval);
        }, 20000);
      }
    );

    window.addEventListener("resize", this.resetActionButtonPosition);
  }

  //---------------------------------------------------------------------------
  componentWillUnmount() {
    window.removeEventListener("resize", this.resetActionButtonPosition);
    clearInterval(this.interval);
  }

  //---------------------------------------------------------------------------
  resetHeaderPosition = () => {
    if ($(".menu-header-container")) {
      let headerHeight = $(".menu-header-container").outerHeight();
      $(".page-content").css("padding-top", headerHeight + 10 + "px");
    }
  };

  //---------------------------------------------------------------------------
  resetActionButtonPosition = () => {
    let windowHeight = $(window).height();
    let documentHeight = $(document).height();
    this.setState({
      setFixedBtn: !(documentHeight > windowHeight),
    });
    this.resetHeaderPosition();
  };

  //---------------------------------------------------------------------------
  onClickDifficultyLevel = (difficultyLevelValue) => {
    this.setState({
      selectedDifficultyLevel: difficultyLevelValue,
    });
  };

  //---------------------------------------------------------------------------
  onClickMaxQuestionsOption = (maxQuestionsValue) => {
    this.setState({
      selectedMaxQuestions: maxQuestionsValue,
    });
  };

  //---------------------------------------------------------------------------
  onClickBegin = () => {
    const { cookies } = this.props;
    let appSettings = cookies.get("app_settings");
    appSettings.quiz_settings.diff = this.state.selectedDifficultyLevel;
    appSettings.quiz_settings.questions = this.state.selectedMaxQuestions;
    cookies.set("app_settings", appSettings);
    this.props.history.push("/fastquiz", { showQuiz: "1" });
  };

  //---------------------------------------------------------------------------
  // Main Render Function
  //---------------------------------------------------------------------------
  render() {
    const {
      difficultyLevelOptions,
      selectedDifficultyLevel,
      maxQuestions,
      selectedMaxQuestions,
      setFixedBtn,
      isLoading,
    } = this.state;
    this.resetHeaderPosition();
    return isLoading ? (
      <LoaderComponent loading={isLoading} />
    ) : (
      <div className="fastquiz-difficulty-page-container">
        <OptionsMenuPageHeader
          goBack={() => {
            this.props.history.goBack();
          }}
          headerTitle="Fast Quiz"
        />
        <div className="page-content">
          <div className="menu-settings-container">
            <div className="content-row">
              <div className="row-title">Choose Difficulty Level:</div>
              <div className="row-data">
                <div className="options-list">
                  {difficultyLevelOptions.map((options, optionsIndex) => {
                    return (
                      <div
                        className="options-list-row"
                        key={"options_" + optionsIndex}
                      >
                        {options.map((optionItem, itemIndex) => {
                          return (
                            <div
                              className={
                                "single-option-box" +
                                (optionItem.value === selectedDifficultyLevel
                                  ? " selected-option-box"
                                  : "")
                              }
                              key={"options_" + optionsIndex + "-" + itemIndex}
                              onClick={() =>
                                this.onClickDifficultyLevel(optionItem.value)
                              }
                            >
                              <div className="box-radio">
                                <div>
                                  <input
                                    id={
                                      "radio_" + optionsIndex + "_" + itemIndex
                                    }
                                    className="radio-custom"
                                    name="difficulty-radio-group"
                                    type="radio"
                                    checked={
                                      optionItem.value ===
                                      selectedDifficultyLevel
                                        ? true
                                        : false
                                    }
                                    value={optionItem.value}
                                    readOnly
                                  />
                                  <label
                                    htmlFor={
                                      "radio_" + optionsIndex + "_" + itemIndex
                                    }
                                    className="radio-custom-label"
                                  ></label>
                                </div>
                              </div>
                              <div className="box-text">
                                <div className="main-text">
                                  {optionItem.title}
                                </div>
                                <div className="sub-text">
                                  {optionItem.sub_title}
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
            <br />
            <div className="content-row">
              <div className="row-title">Max Questions to Fetch:</div>
              <div className="row-data">
                <div className="options-list">
                  {maxQuestions.map((questions, questionsIndex) => {
                    return (
                      <div
                        className="options-list-row"
                        key={"questions_option_" + questionsIndex}
                      >
                        {questions.map((questionItem, itemIndex) => {
                          return (
                            <div
                              className={
                                "single-option-box" +
                                (questionItem.value === selectedMaxQuestions
                                  ? " selected-option-box"
                                  : "")
                              }
                              key={
                                "questions_option_" +
                                questionsIndex +
                                "-" +
                                itemIndex
                              }
                              onClick={() =>
                                this.onClickMaxQuestionsOption(
                                  questionItem.value
                                )
                              }
                            >
                              <div className="box-radio">
                                <div>
                                  <input
                                    id={
                                      "question_radio_" +
                                      questionsIndex +
                                      "_" +
                                      itemIndex
                                    }
                                    className="radio-custom"
                                    name="questions-radio-group"
                                    type="radio"
                                    checked={
                                      questionItem.value ===
                                      selectedMaxQuestions
                                        ? true
                                        : false
                                    }
                                    value={questionItem.value}
                                    readOnly
                                  />
                                  <label
                                    htmlFor={
                                      "question_radio_" +
                                      questionsIndex +
                                      "_" +
                                      itemIndex
                                    }
                                    className="radio-custom-label"
                                  ></label>
                                </div>
                              </div>
                              <div className="box-text">
                                <div className="main-text">
                                  {questionItem.title}
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
          <div
            className={
              "action-btn-container" + (setFixedBtn ? " fixed-position" : "")
            }
          >
            <div className="action-btn" onClick={this.onClickBegin}>
              Begin
            </div>
          </div>
        </div>
      </div>
    );
  }
}

//-----------------------------------------------------------------------------
const mapStateToProps = (state) => {
  return {
    questionSetDetails: state.questionSetDetails,
  };
};

//-----------------------------------------------------------------------------
export default connect(mapStateToProps, {})(FastQuizDifficultyPage);
